"use strict";

export class Header {
    constructor() {
        this.init();
    }

    init() {
        let startPos = 0;
        const html = document.documentElement;
        const header = document.querySelector('.l-header'); // クラス名を指定

        if (!header) return;

        window.addEventListener('scroll', () => {
            if (html.classList.contains('is-anchor-scrolling')) return;

            const scrollPos = window.scrollY || window.pageYOffset;

            // 100px以上スクロールしたか
            if (scrollPos > startPos && scrollPos > 100) {
                header.classList.add('--hide');
            } else {
                header.classList.remove('--hide');
            }
            startPos = scrollPos;
        }, { passive: true });
    }
}

new Header();